import { regex } from 'vuelidate/lib/validators/common'

export default regex('mobileNumber', /^[1-9][0-9]*$/)



// WEBPACK FOOTER //
// ./src/common/mobileNumberValidator.js